/**
 * @file utils.ts
 * @description Утилиты UI-слоя (phase08.5).
 *
 * `cn` — стандартный shadcn-helper для объединения Tailwind-классов с
 * dedup'ом конфликтующих утилит. Использует `clsx` для условных классов +
 * `tailwind-merge` для разрешения конфликтов (например, `p-2` ↔ `p-4`).
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
